<template>
  <div :id="'player-' + player.uuid" class="video-container">
    <template v-if="player.streamType === 'youtube'">
      <iframe
        class="yt-video"
        :src="'https://www.youtube.com/embed/' + player.youtubeCode + '?autoplay=1&modestbranding=1'"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      >
      </iframe>
    </template>
    <template v-else-if="player.streamType === 'rtmp'">
      <digital-event-room-video-js-player :options="player.videoJsOptions"></digital-event-room-video-js-player>
    </template>
    <template v-else-if="player.streamType === 'vimeo'">
      <div style="padding:56.25% 0 0 0;position:relative;" class="vimeo-player">
        <iframe
          :src="player.vimeoUrl"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
          style="position:absolute;top:0;left:0;width:100%;height:100%;"
        ></iframe>
      </div>
    </template>
    <template v-else-if="player.streamType === 'html'">
      <div v-html="player.presentationHTML" class="player-html"></div>
    </template>
    <template v-else-if="player.streamType === 'image'">
      <img :src="player.presentationImage" class="player-image" :alt="player.title" />
    </template>
    <template v-else-if="player.streamType === 'custom'">
      <div v-html="player.customPlayer" class="player-custom"></div>
    </template>
    <template v-else>
      <!-- UNRECOGNISED PLAYER -->
    </template>
  </div>
</template>

<script>
import VideoJsPlayer from "@/components/DigitalEvent/RoomList/Room/Presentation/VideoJsPlayer";

export default {
  name: "VideoJsPlayer",
  components: {
    "digital-event-room-video-js-player": VideoJsPlayer
  },
  props: {
    player: {
      type: Object,
      default: function() {
        return {};
      }
    }
  }
};
</script>
